<template>
	<div class="w-100 over-hidden posi_r">
		<div class="head_nav">
			<head-nav></head-nav>
		</div>
		<div id="ban" class="w-1440">
			<div id="swiperId" class="swiper">
				<swiper :loop="true" :autoplay="autoPlay" :pagination="pagination" :navigation="true"
					:modules="modules">
					<swiper-slide v-for="(slide, index) in banner" :key="index">
						<img :src="slide.img" />
					</swiper-slide>
				</swiper>
				<div class="swiper-pagination"></div>
			</div>

			<div class="b_nav d-flex a-center">
				<div class="son on d-flex a-center j-center" @click="btnClick('login','release')">
					<img src="@/assets/images/ban_ico2.png" />
					需求发布
				</div>
				<div class="son d-flex a-center j-center" @click="btnClick('url','/bidding')">
					<img src="@/assets/images/ban_ico3.png" />
					竞价中心
				</div>
				<!-- /consult -->
				<div class="son dpseek d-flex a-center j-center" @click="btnClick('nyai')">
					<!-- <img src="@/assets/images/ban_ico4.png" /> -->
					<!-- 我要咨询 -->
					<img class="deepseek" src="@/assets/images/ind_b_ai.png" />
				</div>
				<div class="son d-flex a-center j-center" @click="btnClick('url','/financial')">
					<img src="@/assets/images/ban_ico1.png" />
					我要融资
				</div>
				<div class="son d-flex a-center j-center" @click="btnClick('url','/settled')">
					<img src="@/assets/images/ban_ico5.png" />
					入驻单位
				</div>
			</div>
		</div>
	</div>

	<!-- ai漂浮 -->
	<pfai v-if="aiShow" @aiClick="aiShow = false"></pfai>

</template>

<script>
	import pfai from "/src/views/inc/pf_ai.vue";

	import {
		Swiper,
		SwiperSlide
	} from 'swiper/vue';
	import 'swiper/css';
	import 'swiper/css/pagination';
	import 'swiper/css/navigation';
	import {
		Autoplay, //自动播放
		Pagination, //点
		Navigation //左右箭头
	} from 'swiper/modules';

	export default {
		name: 'banner',
		components: {
			Swiper,
			SwiperSlide,
			pfai
		},
		data() {
			return {
				banner: [],
				ban_search_name: '',
				modules: [Autoplay, Pagination, Navigation],
				autoPlay: {
					delay: 2500,
					disableOnInteraction: false,
				},
				pagination: {
					clickable: true,
				},
				aiShow: false,
				loadShow: false
			}
		},
		mounted() {
			this.getBanner()
		},
		methods: {
			btnClick(e, item = '') {
				const that = this
				if (e == 'url') {
					that.$router.push({
						path: item
					})
				} else if (e == 'login') {
					if (that.$common.checkLogin(1)) {
						if (item == 'release') {
							that.$router.push({
								path: '/member/release/list',
								query: {
									type: 'add'
								}
							})
						} else {
							that.$router.push({
								path: item
							})
						}
					}
				} else if (e == 'nyai') {
					if (that.$common.checkLogin(2)) {
						that.aiShow = true
					}
				}

			},

			getBanner() {
				var that = this;

				that.$axios.post(that.$baseUrl.indexBan, {
						class_id: 25
					})
					.then(res => {
						if (res.code == 200) {
							that.banner = res.data

							// var swiper = new Swiper('#swiperId', {
							// 	loop: true,
							// 	autoplay: {
							// 		delay: 3000,
							// 		disableOnInteraction: false,
							// 	},

							// 	// navigation: {
							// 	// 	nextEl: ".swiper-button-next",
							// 	// 	prevEl: ".swiper-button-prev",
							// 	// },
							// });
						} else {
							that.$toast(res.msg);
						}
					})
					.catch(error => {
						console.error(error)
					})
			},

		}
	}
</script>

<style lang="scss" scoped>
	.head_nav {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 60px;
		background: rgba(56, 148, 35, .8);
		z-index: 99;
	}

	#ban {
		height: 614px;
		margin: 0 auto;
		position: relative;


		.b_nav {
			position: absolute;
			width: 1860px;
			left: 56px;
			bottom: 0;
			height: 126px;
			z-index: 12;
			background: rgba(9, 185, 124, .35);
			padding-left: 127px;

			&::after {
				position: absolute;
				width: 398px;
				height: 180px;
				background: url('../../assets/images/ban_tsfw.png');
				left: -294px;
				bottom: 0;
				content: " ";
				display: block;
			}

			.son {
				color: #fff;
				width: 230px;
				font-size: 22px;
				height: 76px;
				box-sizing: border-box;
				margin-right: 14px;
				cursor: pointer;

				img {
					margin-right: 10px;

					&.deepseek {
						margin: 0;
						width: 170px;
					}
				}

				&:hover,
				&.on {
					border-radius: 10px;
					font-weight: bold;
					font-size: 34px;
					box-shadow: 0 0 30px rgba(255, 255, 255, 1);
					border: #fff solid 1px;

					img {

						&.deepseek {
							margin: 0;
							width: 220px;
						}
					}
				}
			}
		}

		.swiper {
			width: 1920px;
			position: absolute;
			left: 50%;
			top: 0;
			height: 614px;
			z-index: 2;
			transform: translateX(-50%);

			.swiper-slide-home {
				height: 100%;
				background-size: cover;
				background-position: center;
				background-repeat: no-repeat;

				.swiper-slide-home-title {
					font-size: 36px;
					font-weight: lighter;
				}

				.swiper-slide-home-desc {
					font-size: 20px;
					font-weight: lighter;
				}
			}
		}
	}
</style>